/**
 * Child document types that are derived artifacts of their parent document
 * (screenshots / embedded images generated during processing). These are
 * hidden from evidence lists, counts, and citation views because the parent
 * document already represents them.
 *
 * Child types NOT in this set (e.g. "msg_attachment") are first-class
 * documents in their own right and must remain visible everywhere, even
 * though they carry a parentDocumentId. New/unknown child types default to
 * first-class.
 */
export const DERIVED_CHILD_TYPES: ReadonlySet<string> = new Set([
  "excel_screenshot",
  "text_screenshot",
  "excel_embedded_image",
  "video_screenshot",
]);

/**
 * Derived child types that are rendered screenshots of a region of their
 * parent document. A cited screenshot stands in for the parent's citation of
 * the same region (the pair shares an `encodedCitationString`). Embedded
 * images are extracted content rather than a rendering of the parent, so they
 * are not screenshots.
 */
export const SCREENSHOT_CHILD_TYPES: ReadonlySet<string> = new Set([
  "excel_screenshot",
  "text_screenshot",
  "video_screenshot",
]);

export function isDerivedChildDocument(doc: {
  childType?: string | null;
  parentDocumentId?: string | null;
}): boolean {
  return (
    doc.parentDocumentId != null &&
    doc.childType != null &&
    DERIVED_CHILD_TYPES.has(doc.childType)
  );
}

export function isScreenshotChildType(
  childType: string | null | undefined,
): boolean {
  return childType != null && SCREENSHOT_CHILD_TYPES.has(childType);
}
